const sources = [
    {
        name: 'retroOfficeModel',
        type: 'gltfModel',
        path: 'models/retro_office/retro_office.glb',
    },
    {
        name: 'tBottomDrawer',
        type: 'texture',
        path: 'models/retro_office/T_BottomDrawer.png',
    },
    {
        name: 'tCable01',
        type: 'texture',
        path: 'models/retro_office/T_Cable01.png',
    },
    {
        name: 'tCable02',
        type: 'texture',
        path: 'models/retro_office/T_Cable02.png',
    },
    {
        name: 'tCable03',
        type: 'texture',
        path: 'models/retro_office/T_Cable03.png',
    },
    {
        name: 'tDesk',
        type: 'texture',
        path: 'models/retro_office/T_Desk.png',
    },
    {
        name: 'tKeyboard',
        type: 'texture',
        path: 'models/retro_office/T_Keyboard.png',
    },
    {
        name: 'tMonitor',
        type: 'texture',
        path: 'models/retro_office/T_Monitor.png',
    },
    {
        name: 'tMouse',
        type: 'texture',
        path: 'models/retro_office/T_Mouse.png',
    },
    {
        name: 'tPCCase',
        type: 'texture',
        path: 'models/retro_office/T_PCCase.png',
    },
    {
        name: 'tPCFrontCase',
        type: 'texture',
        path: 'models/retro_office/T_PCFrontCase.png',
    },
    {
        name: 'tRoom',
        type: 'texture',
        path: 'models/retro_office/T_Room.png',
    },
    {
        name: 'tTopDrawer',
        type: 'texture',
        path: 'models/retro_office/T_TopDrawer.png',
    },
    {
        name: 'monitorSmudgeTexture',
        type: 'texture',
        path: 'textures/monitor/layers/compressed/smudges.jpg',
    },
    {
        name: 'monitorShadowTexture',
        type: 'texture',
        path: 'textures/monitor/layers/compressed/shadow-compressed.png',
    },
    {
        name: 'mouseDown',
        type: 'audio',
        path: 'audio/mouse/mouse_down.mp3',
    },
    {
        name: 'mouseUp',
        type: 'audio',
        path: 'audio/mouse/mouse_up.mp3',
    },
    {
        name: 'keyboardKeydown1',
        type: 'audio',
        path: 'audio/keyboard/key_1.mp3',
    },
    {
        name: 'keyboardKeydown2',
        type: 'audio',
        path: 'audio/keyboard/key_2.mp3',
    },
    {
        name: 'keyboardKeydown3',
        type: 'audio',
        path: 'audio/keyboard/key_3.mp3',
    },
    {
        name: 'keyboardKeydown4',
        type: 'audio',
        path: 'audio/keyboard/key_4.mp3',
    },
    {
        name: 'keyboardKeydown5',
        type: 'audio',
        path: 'audio/keyboard/key_5.mp3',
    },
    {
        name: 'keyboardKeydown6',
        type: 'audio',
        path: 'audio/keyboard/key_6.mp3',
    },
    {
        name: 'startup',
        type: 'audio',
        path: 'audio/startup/startup.mp3',
    },
    {
        name: 'office',
        type: 'audio',
        path: 'audio/atmosphere/office.mp3',
    },
    {
        name: 'ccType',
        type: 'audio',
        path: 'audio/cc/type.mp3',
    },
];
export default sources;
